window.JUST_CUSTOMV2_FN = async (customSource) => {
  // Utility Functions
  const showLoading = (show = true) => {
    const alert = document.getElementById("customLoading");
    if (alert) {
      alert.style.display = show ? "block" : "none";
    }
  };

  const toggleCartDrawer = (hide = true) => {
    const drawer = document.querySelector("cart-drawer-z");
    if(drawer) {
      drawer.style.display =  hide ? 'none' : 'flex';
    }
  }

  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const safeFetch = async (url, options = {}) => {
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  };

  // Cart Management Functions
  const fetchCart = async () => {
    const response = await safeFetch("/cart.js");
    return response.json();
  };

  const clearCart = async () => {
    await safeFetch("/cart/clear.js", { method: "POST" });
  };

  const addToCart = async (item) => {
    await safeFetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(item),
    });
  };

  const restoreCart = async (originalCart) => {
    if (!originalCart.items?.length) return;

    await clearCart();

    for (const item of originalCart.items) {
      await addToCart({
        id: item.variant_id,
        quantity: item.quantity,
        properties: item.properties || {},
      });
    }
  };

  const processCartItems = async (cart) => {
    const cartItems = cart.items.map((item) => ({
      variantId: item.variant_id,
      quantity: item.quantity,
      properties: { ...item?.properties },
    }));

    return { items: [...cartItems] };
  };

  // Product Form Handler Functions
  const extractProperties = (form) => {
    return Array.from(form.querySelectorAll("input, textarea, select"))
      .filter((el) => el.name?.includes("properties") && el.value)
      .map((el) => {
        const match = el.name?.match(/\[(.*?)\]/);
        return { key: match?.[1] ?? "", value: el.value };
      })
      .filter((prop) => prop.value)
      .reduce((acc, prop) => {
        acc[prop.key] = prop.value;
        return acc;
      }, {});
  };

  const extractProductData = (productId) => {
    const selector = `[product_id="${productId}"]`;
    const btn = document.querySelector(selector);

    if (!btn) throw new Error("Product button not found");

    const form = btn.closest("form");
    if (!form) throw new Error("Product form not found");

    const variantId = parseInt(form.querySelector(".product-variant-id").value);
    const quantity = parseInt(
      form.querySelector('[name="quantity"]')?.value ||
        document.querySelector('[name="quantity"]')?.value ||
        document.querySelector(".product-form__input--quantity")?.value ||
        "1"
    );

    const properties = extractProperties(form);

    return { variantId, quantity, properties };
  };

  // Main Logic
  toggleCartDrawer();
  showLoading(true);

  try {
    // Handle product form
    const { variantId, quantity, properties } =
      extractProductData(customSource);

    // Store original cart state
    const originalCart = await fetchCart();
    window.tlog("Original cart:", originalCart);

    try {
      // Clear cart and add new item
      await clearCart();
      await addToCart({ id: variantId, quantity, properties });

      // Wait for processing
      await sleep(3000);

      // Get updated cart
      const newCart = await fetchCart();
      window.tlog("New cart with added variant:", newCart);

      // Restore original cart
      await restoreCart(originalCart);
      window.tlog("Cart restored to original state");

      return await processCartItems(newCart);
    } catch (error) {
      console.error("Error during cart operations:", error);
      await restoreCart(originalCart);
      throw error;
    }
  } catch (error) {
    console.error("Integration error:", error);
    throw error;
  } finally {
    setTimeout(() => {
      toggleCartDrawer(false);
      showLoading(false);
    }, 1000);
    
  }
};
